export const siteInfo = {
  brand: "风间由美",
  brandEn: "KAZAMA YUMI",
  slogan: "官方资讯与最新动态",
  intro:
    "风间由美官方网站，是面向粉丝与关注者的官方信息发布平台，聚合最新新闻、作品介绍与日常动态，并提供粉丝交流与官方精选内容。",
  aboutIntro:
    "风间由美，演员、歌手。自出道以来，她在电影、电视剧与音乐领域持续探索，以克制的表演与真诚的创作受到关注。",
  aboutParagraphs: [
    "风间由美最初以音乐作品进入公众视野，随后转向影视表演。她善于处理细腻而复杂的情感，尤其擅长在沉默与留白中传递人物的内心波动。",
    "在表演之外，她长期参与公益阅读项目，并保持着手写日记与摄影的习惯。她说这些看似无关的日常，反而是理解角色最重要的部分。",
    "本官方网站由风间由美工作室运营，用于发布官方资讯、作品信息与活动公告。所有内容以官方渠道发布为准。",
  ],
  email: "hello@kazamayumi-official.com",
  pressEmail: "press@kazamayumi-official.com",
  address: "官方工作室 · 线上联络为主",
  socials: [
    { name: "官方微博", handle: "@风间由美工作室", icon: "ri-weibo-line" },
    { name: "官方公众号", handle: "风间由美 Official", icon: "ri-wechat-line" },
    { name: "视频频道", handle: "KAZAMA YUMI Channel", icon: "ri-youtube-line" },
    { name: "音乐主页", handle: "风间由美 · 音乐", icon: "ri-music-2-line" },
  ],
  copyright: `© ${new Date().getFullYear()} 风间由美官方网站 · 风间由美工作室 保留所有权利`,
  disclaimer:
    "本网站为风间由美个人品牌官方资讯平台，站内人物、作品及相关内容为展示用途。部分案例与数据为示例信息，仅用于说明网站功能，如有出入以官方正式公告为准。",
};

export const navLinks = [
  { name: "首页", path: "/" },
  { name: "新闻", path: "/news" },
  { name: "作品", path: "/works" },
  { name: "粉丝交流", path: "/fans" },
  { name: "关于", path: "/about" },
  { name: "联系", path: "/contact" },
];